import { cva } from 'class-variance-authority'

import { Actions } from '../components/actions/Actions'
import { ActionHandler, BatchActionHandler } from '../logic/types'
import { SettingsDialog } from '../settings-dialog/components/SettingsDialog'
import { UseSettingsDialogResult } from '../settings-dialog/logic/useSettingsDialog'
import { ActionsGridLayout } from '../types'
import { useActionsSharedState } from '@/domain/state/actions-shared-state'
import { Info } from '@/ui/molecules/info/Info'
import { cn } from '@/ui/utils/style'

const actionsTitleVariants = cva('', {
  variants: {
    layout: {
      extended: 'typography-heading-5 text-primary',
      compact: 'typography-label-3 text-secondary',
    },
  },
})

export interface ActiveActionsViewProps {
  actionHandlers: ActionHandler[]
  batchActionHandler: BatchActionHandler | undefined
  actionsGridLayout: ActionsGridLayout
  settingsDialogProps: UseSettingsDialogResult
  allowChangeWhenActionsInProgress: boolean
  canWalletBatch: boolean
}

export function ActiveActionsView({
  actionHandlers,
  batchActionHandler,
  actionsGridLayout,
  settingsDialogProps,
  allowChangeWhenActionsInProgress,
  canWalletBatch,
}: ActiveActionsViewProps) {
  const { actionsSettingsEnabled: _actionsSettingsEnabled } = useActionsSharedState()
  const actionsSettingsEnabled = allowChangeWhenActionsInProgress ? true : _actionsSettingsEnabled

  return (
    <section className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <h3 className={cn(actionsTitleVariants({ layout: actionsGridLayout }))}>
          Actions
          {canWalletBatch && (
            <Info className="ml-1 inline">
              Your wallet supports transaction batching. Adjust batching preferences in the actions settings.
            </Info>
          )}
        </h3>
        {import.meta.env.VITE_BASE_MINI_APP !== '1' && (
          <SettingsDialog
            {...settingsDialogProps}
            disabled={!actionsSettingsEnabled}
            actionsGridLayout={actionsGridLayout}
          />
        )}
      </div>
      <Actions actionHandlers={actionHandlers} batchActionHandler={batchActionHandler} layout={actionsGridLayout} />
    </section>
  )
}
